function state2023() {
    $('.expand-top-cities').on('click', () => {
        $('.top-cities').slideToggle(2000);
        $('.expand-top-cities').toggleClass('active');
    });

    const barObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const intersecting = entry.isIntersecting;
            if (intersecting) {
                const setValue = entry.target.dataset.value;
                const animateIt = setInterval(() => {
                    if (entry.target.value < setValue) {
                        entry.target.value++;
                    } else {
                        clearInterval(animateIt);
                    }
                }, 10);
            }
        });
    });

    document.querySelectorAll('progress.animate-in').forEach((i) => {
        barObserver.observe(i);
    });

    // reset to 0, left value on html for SEO
    $('.bar-num').html('0%');

    const numObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const intersecting = entry.isIntersecting;
            if (intersecting) {
                const setValue = entry.target.dataset.value;
                const animateIt = setInterval(() => {
                    const currentVal = parseInt(entry.target.innerHTML);
                    if (currentVal < setValue) {
                        entry.target.innerHTML = `${currentVal + 1}%`;
                    } else {
                        clearInterval(animateIt);
                    }
                }, 10);
            }
        });
    });

    document.querySelectorAll('.bar-num').forEach((i) => {
        numObserver.observe(i);
    });
}

export { state2023 };
